import {useEffect} from 'react'
import {MessageModalHeader} from './MessageModalHeader'
import {MessageModalFormWrapper} from './MessageModalFormWrapper'

export const MessageModal = ({ messageType, setShowMessageModal, getUser, user }) => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-650px`}>
          <div className='modal-content'>
            <MessageModalHeader setShowMessageModal={setShowMessageModal} messageType={messageType} />
            <div className={`modal-body scroll-y mx-5  mx-xl-15 my-7`}>
              <MessageModalFormWrapper setShowMessageModal={setShowMessageModal} messageType={messageType} getUser={getUser} user={user} />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'/>
    </>
  )
}
